<template>
  <div class="media-gallery-image-item">
    <img :src="item.image.url" />
  </div>
</template>

<script>

export default {
  name: 'MediaGalleryImageItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};

</script>

<style scoped>

.media-gallery-image-item img {
  max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/MediaGalleryImageItem.vue